
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"レイヤー 2"}},[_c('path',{attrs:{"d":"M28.5 21a3.51 3.51 0 00-3.2 2.09L7 18a3.44 3.44 0 000-.45 3.37 3.37 0 00-.43-1.64L20 6a3.49 3.49 0 10-1-2.5 3.37 3.37 0 00.43 1.64L6 15a3.5 3.5 0 10.71 3.87l18.35 5.14a3.44 3.44 0 00-.05.45A3.5 3.5 0 1028.5 21zm-6-20A2.5 2.5 0 1120 3.5 2.5 2.5 0 0122.5 1zm-19 19A2.5 2.5 0 116 17.5 2.5 2.5 0 013.5 20zm25 7a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z","data-name":"レイヤー 1"}})])])
          )
        }
      }
    